import React from 'react';
import Layout from '../components/Layout';

const Gallery = () => {
  const images = [
    "/gallery/img1.jpg",
    "/gallery/img2.jpg",
    "/gallery/img3.jpg",
    "/gallery/img4.jpg",
    "/gallery/img5.jpg",
    "/gallery/img6.jpg",
  ];

  return (
    <Layout>
      {/* Container principal cu relative z-20 pentru a suprascrie overlay-ul Layout */}
      <div className="relative z-20 min-h-screen py-20 px-4">

        {/* Titlu */}
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-6xl font-bold bg-gradient-to-r from-[#025951] to-emerald-400 bg-clip-text text-transparent">
            Case Gallery
          </h1>
          <p className="mt-6 text-lg md:text-xl text-gray-700 dark:text-gray-300 max-w-3xl mx-auto">
            A selection of implant and full-arch cases designed with precision and digital workflow expertise.
          </p>
          <div className="w-24 h-1 bg-gradient-to-r from-[#025951] to-emerald-400 mx-auto rounded-full mt-6"></div>
        </div>

        {/* Grid imagini */}
        <div className="max-w-7xl mx-auto grid sm:grid-cols-2 md:grid-cols-3 gap-8">
          {images.map((src, index) => (
            <div
              key={index}
              className="overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 group dark:bg-neutral-800"
            >
              <img
                src={src}
                alt={`Case ${index + 1}`}
                className="w-full h-72 object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
          ))}
        </div>

      </div>
    </Layout>
  );
};

export default Gallery;